import { createAction, props } from '@ngrx/store';

export const clickHamburger = createAction('[Menu] Hamburger click', props<{ collapsedMenu: boolean }>());

export const getMenuData = createAction('[Menu] Get Data', props<{ apiConstants: any }>());

export const setMenuData = createAction('[Menu] Set Data', props<{ menuData: any[] }>());

export const toggleSideBar = createAction(
  '[Menu] Toggle Side Bar',
  props<{ toggleSideBar: { lastToggledTime?: Date; isFullscreenMode?: boolean } }>()
);
